var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountInfoGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.994 -1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "nonzero",
    d: "M12,1.33333333 C6.10666667,1.33333333 1.33333333,6.10666667 1.33333333,12 C1.33333333,17.8933333 6.10666667,22.6666667 12,22.6666667 C17.8933333,22.6666667 22.6666667,17.8933333 22.6666667,12 C22.6666667,6.10666667 17.8933333,1.33333333 12,1.33333333 Z M12,5 C13.6533333,5 15,6.34666667 15,8 C15,9.65333333 13.6533333,11 12,11 C10.3466667,11 9,9.65333333 9,8 C9,6.34666667 10.3466667,5 12,5 Z M12,19.3333333 C9.52,19.3333333 7.34666667,18.1066667 6.01333333,16.2266667 C6.16,14.2933333 10.04,13.3333333 12,13.3333333 C13.96,13.3333333 17.84,14.2933333 17.9866667,16.2266667 C16.6533333,18.1066667 14.48,19.3333333 12,19.3333333 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInfoGrey);
export default __webpack_public_path__ + "static/media/account-info-grey.2d0caabf.svg";
export { ForwardRef as ReactComponent };